import React, { useMemo } from 'react';
import { Image, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { CardView, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { Tier } from 'features/premium/entities';
import { selectUserTier } from 'features/premium/selectors/tier';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
const FSCSImg = require('../img/FSCS.png');
// currency symbol followed by digits, with optional , or . separators
const AMOUNT_REGEX = /([£$€]\s?\d[\d,.]*\d|[£$€]\s?\d)/;
const PotTypeCard = ({ name, onPress, bankLogo, productId, isCashISA, description, fscsBrochure, isOnboarding, showInterest, isRecommended, interestPaymentFrequency, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const activeTier = useAppSelector(selectUserTier);
    const interestPotProductsTierRateMap = useAppSelector((store) => store.pots.interestPotProductsTierRateMap);
    const rateToDisplay = interestPotProductsTierRateMap?.[productId]?.[isOnboarding ? Tier.ultimate : activeTier];
    const desc = useMemo(() => (<Text TextThin-14 Secondary>
        {description.split(AMOUNT_REGEX).map((part, index) => index % 2 === 1 ? (<Text key={index} NumbersThin-14 Secondary>
              {part}
            </Text>) : (part))}
      </Text>), [description]);
    return (<TouchableBounce onPress={onPress} testID="potProductCard">
      <CardView noMarginBottom style={styles.cardView}>
        <View style={styles.topContainer}>
          <View style={styles.row}>
            <View style={styles.flex1}>
              {!!isRecommended && (<Text Text-12 Primary>
                  {isCashISA ? 'MOST POPULAR' : 'RECOMMENDED'}
                </Text>)}
              <Text Text-16>{name}</Text>
              {!!showInterest && !!rateToDisplay && (<Text TextThin-14 Secondary>
                  {isOnboarding && activeTier !== Tier.ultimate ? 'Up to ' : ''}
                  <Text Numbers-14 Primary>
                    {rateToDisplay}%
                  </Text>
                  {' AER'}
                  {interestPaymentFrequency ? `, paid ${interestPaymentFrequency.toLowerCase()}` : ''}
                </Text>)}
            </View>
            <Spacer w={16}/>
            {!!fscsBrochure && (<Image source={FSCSImg} testID="FSCSImg" resizeMode="contain" tintColor={colors.elements.secondary} style={styles.fscsImg}/>)}
          </View>
          <Spacer h={8}/>
          {desc}
        </View>
        {!!bankLogo && (<>
            <Spacer h={16}/>
            <View style={styles.line}/>
            <Spacer h={16}/>
            <View style={styles.bottomContainer}>
              {!!bankLogo && (<View>
                  <Text TextThin-14 Secondary>
                    Provided by
                  </Text>
                </View>)}
              <View style={styles.flex1}/>
              <Image testID="bankImg" source={{ uri: bankLogo }} style={styles.bankLogo} resizeMode="contain"/>
            </View>
          </>)}
      </CardView>
    </TouchableBounce>);
};
export default PotTypeCard;
const styleSet = createStyleSheets((colors) => ({
    row: {
        flexDirection: 'row',
    },
    topContainer: {
        paddingHorizontal: rem(16),
    },
    bottomContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        paddingHorizontal: rem(16),
    },
    flex1: {
        flex: 1,
    },
    line: {
        height: 1,
        flex: 1,
        backgroundColor: colors.background.dark,
    },
    interestContainer: {
        alignItems: 'flex-end',
    },
    bankLogo: {
        width: rem(84),
        height: rem(21),
        tintColor: colors.elements.secondary,
    },
    cardView: {
        paddingVertical: rem(16),
    },
    fscsImg: {
        width: rem(36),
        height: rem(25),
    },
}));
